import crayolasJson from '@/assets/crayolas'
import moment from 'moment'
import { TimeRanges, CustomTimeRangeTypes, ReportConversionUtil } from '@colven/common-domain-lib/lib'
import i18n from '@/i18n'

/**
 * Método para seleccionar aleatoriamente los colores de los gráficos de torta/dona
 * @param {*} usedColors
 */
export const pickColor = function (usedColors) {
    let color = crayolasJson[Math.floor(Math.random() * crayolasJson.length)].hex
    if (usedColors && usedColors.length > 0) {
        let i = 0
        while (i < crayolasJson.length && usedColors.includes(color)) {
            color = crayolasJson[Math.floor(Math.random() * crayolasJson.length)].hex
            i++
        }
        return color
    } else {
        return color
    }
}
/**
 * Para comparar objetos
 * @param {*} o1
 * @param {*} o2
 */
export const objectsEqual = function (o1, o2) {
    if (!o1 && !o2) {
        return true
    } else {
        return typeof o1 === 'object' && Object.keys(o1).length > 0
            ? Object.keys(o1).length === Object.keys(o2).length &&
            Object.keys(o1).every(p => objectsEqual(o1[p], o2[p]))
            : o1 === o2
    }
}

export const distinct = function (o1, o2) {
    if (o1 && o2) {
        return o1._id !== o2._id
    }
    return true
}
/**
 * Para comparar arrays
 * @param {*} a1
 * @param {*} a2
 */
export const arraysEqual = function (a1, a2) {
    return a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]))
}
/**
 * Función para mostrar un elemento html en pantalla completa
 * @param {*} elem
 */
export const toggleFullscreen = function (elem) {
    elem = elem || document.documentElement
    if (!document.fullscreenElement && !document.mozFullScreenElement &&
        !document.webkitFullscreenElement && !document.msFullscreenElement) {
        if (elem.requestFullscreen) {
            elem.requestFullscreen()
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen()
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen()
        } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
        }
        return 'fullscreen_exit'
    } else {
        if (document.exitFullscreen) {
            document.exitFullscreen()
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
        }
        return 'fullscreen'
    }
}

/**
 * Función para eliminar hijos de una lista multinivel
 * @param {*} list
 * @param {*} children
 */
export const removeChildren = function (list, children) {
    children.forEach(child => {
        removeItem(list, child)
    })
}

/**
 * Función recursiva para eliminar un hijo de una lista multinivel
 * @param {*} list
 * @param {*} item
 */
export const removeItem = function (list, item) {
    list.forEach(object => {
        if (object.id === item.id) {
            return list.splice(list.indexOf(object), 1)
        } else if (object.children && object.children.length > 0) {
            removeItem(object.children, item)
        }
    })
}

/**
 * Función para agregar un hijo (o un arreglo de hijos) a una lista multinivel
 * @param {*} list
 * @param {*} item
 */
export const addToList = function (list, item) {
    if (item instanceof Array) {
        item.forEach(i => {
            addItemToList(list, i)
        })
    } else {
        addItemToList(list, item)
    }
}

/**
 * Función recursiva para agregar un hijo a una lista multinivel
 * @param {*} list
 * @param {*} item
 */
export const addItemToList = function (list, item) {
    if (!item.father) {
        list.push(item)
    } else {
        list.forEach(listItem => {
            if (listItem.id === item.father && listItem.children) {
                listItem.children.push(item)
            } else if (listItem.id !== item.father && listItem.children) {
                addItemToList(listItem.children, item)
            }
        })
    }
}

/**
 * Devuelve los nodos hoja de una lista andidada
 * @param {*} list
 * @param {*} result
 */
export const getChildrenFromList = function (list, result) {
    list.forEach(item => {
        if (item.children) {
            getChildrenFromList(item.children, result)
        } else {
            result.push(item)
        }
    })
}

/**
 * Devuelve los ids de los nodos hoja de una lista andidada
 * @param {*} list
 * @param {*} result
 */
export const getChildrenIdFromList = function (list, result) {
    list.forEach(item => {
        if (item.children) {
            getChildrenIdFromList(item.children, result)
        } else {
            result.push(item.id)
        }
    })
}

/**
 * Búsqueda recursiva en una lista anidada
 * @param {*} list
 * @param {*} id
 */
export const findById = function (list, id) {
    for (let node of list) {
        if (node.id === id) return node

        if (node.children) {
            let desiredNode = findById(node.children, id)
            if (desiredNode) return desiredNode
        }
    }
    return false
}

/**
 * Devuelve los ids de los elementos de la lista (si tienen hijos, devuelve los id de los hijos)
 * @param {*} list
 * @param {*} result
 */
export const getIds = function (list, result) {
    list.forEach(item => {
        if (item.children && item.children.length > 0) {
            getIds(item.children, result)
        } else {
            result.push(item.id)
        }
    })
}

export const getItemsById = function (list, ids, result) {
    ids.forEach(id => {
        getItemById(list, id, result)
    })
}

export const getItemById = function (list, id, result) {
    list.forEach(item => {
        if (item.id === id) {
            result.push(item)
        } else if (item.children && item.children.length > 0) {
            getItemById(item.children, id, result)
        }
    })
}

/**
 * A partir de una lista anidada, obtener los ids de los nodos hojas de los nodos de mayor jerarquía que se envían como param (ids)
 * @param {*} list
 * @param {*} ids
 */
export const getChildrenByIds = (list, ids) => {
    const result = []
    let node = []
    ids.forEach(id => {
        getItemById(list, id, node)
        getChildrenFromList(node, result)
        node = []
    })
    return result
}

export const toCamelCase = function (str) {
    str = str.split(" ");

    for (var i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1).toLowerCase();
    }

    return str.join(" ");
}

export const formatDate = function (date) {
    if (!date) return null
    const [year, month, day] = date.split('-')
    return `${month}/${day}/${year}`
}

export const getDateTimeRange = function (selectedDateAndTimeRange, selectedDateAndTimeRangeType, sinceDate, sinceTime, toDate, toTime) {
    let tFrom
    let tTo
    const to = moment()
    const from = moment()
    const harvestStartTime = localStorage.getItem('harvestStartTime')
        ? Number(JSON.parse(localStorage.getItem('harvestStartTime')).start)
        : undefined
    let timezone = localStorage.getItem('timezone')
    timezone = timezone ? parseInt(timezone) : -(new Date().getTimezoneOffset() / 60)
    switch (selectedDateAndTimeRange) {
        case TimeRanges.LAST_HOUR:
            // lastHour
            tFrom = from.subtract(1, 'hours').unix()
            tTo = to.unix()
            break
        case TimeRanges.LAST_SIX_HOUR:
            // lastSixHours
            tFrom = from.subtract(6, 'hours').unix()
            tTo = to.unix()
            break
        case TimeRanges.TODAY:
            tFrom = moment.utc().startOf('day').subtract(timezone, 'hours').unix()
            tTo = to.unix()
            break
        case TimeRanges.YESTERDAY:
            tFrom = moment.utc().subtract(1, 'days').startOf('day').subtract(timezone, 'hours').unix()
            tTo = moment.utc().subtract(1, 'days').endOf('day').subtract(timezone, 'hours').unix()
            break
        case TimeRanges.LAST_WEEK:
            // lastWeek
            tFrom = from.subtract(1, 'weeks').unix()
            tTo = to.unix()
            break
        case TimeRanges.ENTERPRISE:
            // enterprise
            tFrom = getEnterpriseCustomTimeSpan()
            tTo = to.unix()
            break
        case TimeRanges.ENTERPRISE_PREVIOUS:
            // jornada anterior
            // El fin de la jornada anteriro es el mismo que el inicio de la jornada diaria
            tTo = getEnterpriseCustomTimeSpan()
            // El inicio de la jornada anterior es el mismo inicio que el de la jornada diaria restandole 24hs
            tFrom = moment.unix(tTo).subtract(1, 'days').unix()
            break
        case TimeRanges.HARVEST_START:
            // desde inicio de zafra
            if (harvestStartTime) {
                tFrom = harvestStartTime
            } else {
                tFrom = from.unix()
            }
            tTo = from.unix()
            break
        case TimeRanges.CUSTOM:
            // custom
            switch (selectedDateAndTimeRangeType) {
                case CustomTimeRangeTypes.DATE_AND_TIME:
                    // date and time
                    tTo = moment(toDate + ' ' + toTime, 'YYYY-MM-DD hh:mm').unix()
                    tFrom = moment(sinceDate + ' ' + sinceTime, 'YYYY-MM-DD hh:mm').unix()
                    break
                case CustomTimeRangeTypes.DATE:
                    // only date
                    tTo = moment(toDate, 'YYYY-MM-DD').unix()
                    tFrom = moment(sinceDate, 'YYYY-MM-DD').unix()
                    break
                case CustomTimeRangeTypes.TIME:
                    // only time
                    // TO DO: todavía no se implementó en el backend
                    break
            }
            break
    }
    return { tFrom, tTo }
}

/**
 * Obtener el timestamp de inicio de la jornada diaria actual
 * @returns
 */
export const getEnterpriseCustomTimeSpan = () => {
    const enterpriseTimeSpan = JSON.parse(localStorage.getItem('enterpriseTimeSpan'))
    const customTimeSpan = enterpriseTimeSpan != null && enterpriseTimeSpan.start != null
        ? enterpriseTimeSpan.start
        : 0
    const now = moment.utc()
    const dateTo = moment.utc().set('minutes', 0).set('seconds', 0).set('milliseconds', 0)
    let from
    if (now.hour() < customTimeSpan) {
        from = dateTo.subtract(1, 'days').set('hours', Math.trunc(customTimeSpan)).unix()
    } else {
        from = dateTo.set('hours', Math.trunc(customTimeSpan)).unix()
    }
    return from
}

export const sortFunction = function (a, b) {
    const nameA = a.name.toLowerCase()
    const nameB = b.name.toLowerCase()
    if (nameA < nameB) {
        return -1
    } else if (nameA > nameB) {
        return 1
    } else {
        return 0
    }
}

export const dateSortFunction = function (a, b, format) {
    const dateA = moment(a, format)
    const dateB = moment(b, format)
    if (!dateA.isValid() && dateB.isValid()) {
        return -1
    } else if (dateA.isValid() && !dateB.isValid()) {
        return 1
    } else if (!dateA.isValid() && !dateB.isValid()) {
        return 0
    } else if (dateA.isBefore(dateB)) {
        return -1
    } else if (dateA.isAfter(dateB)) {
        return 1
    } else {
        return 0
    }
}

/**
 * Función para validar el rango de fechas personalizado del selector, utiliza el valor del formulario
 * @param {*} selectedDateAndTimeRange
 * @param {*} selectedDateAndTimeRangeCustomType
 * @param {*} customDateTimeValidForm
 * @param {*} sinceDate
 * @param {*} sinceTime
 * @param {*} toDate
 * @param {*} toTime
 */
export const selectorDateTimeValidation = function (selectedDateAndTimeRange, selectedDateAndTimeRangeCustomType, customDateTimeValidForm, sinceDate, sinceTime, toDate, toTime) {
    return (selectedDateAndTimeRange === TimeRanges.CUSTOM && !customDateTimeValidForm) || (selectedDateAndTimeRange === TimeRanges.CUSTOM && dateAndTimeRangeEmptyFields(selectedDateAndTimeRangeCustomType, sinceDate, sinceTime, toDate, toTime, false))
}

export const dateAndTimeRangeEmptyFields = function (selectedDateAndTimeRangeCustomType, sinceDate, sinceTime, toDate, toTime, all) {
    switch (selectedDateAndTimeRangeCustomType) {
        case CustomTimeRangeTypes.DATE_AND_TIME:
            if (all) {
                return !toDate && !toTime && !sinceDate && !sinceTime
            } else {
                return !toDate || !toTime || !sinceDate || !sinceTime
            }
        case CustomTimeRangeTypes.DATE:
            if (all) {
                return !toDate && !sinceDate
            } else {
                return !toDate || !sinceDate
            }
        case CustomTimeRangeTypes.TIME:
            if (all) {
                return !toTime && !sinceTime
            } else {
                return !toTime || !sinceTime
            }
    }
}


/**
 * Convierte un arreglo a texto formateado para una cantidad de elementos definida
 * @param {*} array
 * @param {*} length
 */
export const arrayToTextFormatted = (array, length = 5) => {
    let text = ''
    if (array.length > length) {
        const count = array.length - length
        array = array.slice(0, length)
        text = array.toString().replace('[', '').replace(']', '').replace(/,/g, ', ') + ' ' + i18n.t('treeselect.andMore', { count })
    } else {
        text = array.toString().replace('[', '').replace(']', '').replace(/,/g, ', ')
    }
    return text
}

/**
 * Para extraer cadenas de texto de un texto que estén entre dos caracteres
 * Se usa para parsear el archivo de comandos en la carga masiva
 * @param {*} param0
 */
export const extract = ([beg, end]) => {
    const matcher = new RegExp(`${beg}(.*?)${end}`, 'gm');
    const normalise = (str) => str.slice(beg.length, end.length * -1);
    return function (str) {
        const match = str.match(matcher)
        return match ? match.map(normalise) : [];
    }
}

/**
 * Convierte el rango de tiempo de un reporte a string
 * @param {*} timeRange
 * @param {*} timestampFrom
 * @param {*} timestampTo
 */
export const reportTimeRangeDetail = (timeRange, timestampFrom, timestampTo) => {
    // nombres de rangos de tiempo
    const timeNames = {}
    timeNames[TimeRanges.YESTERDAY] = i18n.t('selector.dateAndTime.yesterday')
    timeNames[TimeRanges.LAST_HOUR] = i18n.t('selector.dateAndTime.lastHour')
    timeNames[TimeRanges.LAST_SIX_HOUR] = i18n.t('selector.dateAndTime.lastSixHours')
    timeNames[TimeRanges.LAST_WEEK] = i18n.t('selector.dateAndTime.lastWeek')
    timeNames[TimeRanges.TODAY] = i18n.t('selector.dateAndTime.today')
    timeNames[TimeRanges.CUSTOM] = i18n.t('selector.dateAndTime.custom')

    // timestamps
    const fromStr = timestampFrom
        ? moment.unix(timestampFrom).format('DD/MM/YYYY HH:mm:ss')
        : undefined
    const toStr = timestampTo
        ? moment.unix(timestampTo).format('DD/MM/YYYY HH:mm:ss')
        : undefined

    const result = {
        timeRange: `${i18n.t('selector.dateAndTime.label')}: ${timeNames[timeRange]}`,
        from: fromStr ? `${i18n.t('since')}: ${fromStr}` : undefined,
        to: toStr ? `${i18n.t('to')}: ${toStr}` : undefined
    }

    return result
}

/**
 * Función para validar si un objeto es vacío
 * @param {*} value
 */
export const isEmpty = (value) => {
    if (value === null)
        return true

    if (typeof value == 'object' && Object.keys(value).length === 0)
        return true

    if (typeof value == 'string' && value.trim() == '')
        return true

    return false;
}

/**
 * Remover claves vacías de un objeto JSON
 * @param {*} input
 */
export const removeEmptyFields = (input) => {
    if (Array.isArray(input)) {
        // si es un arreglo, itero sobre todos los elementos
        for (let index = input.length - 1; index >= 0; index--) {
            if (typeof input[index] == 'object') {
                removeEmptyFields(input[index])
            }
            if (isEmpty(input[index])) {
                input.splice(index, 1)
            }
        }
    } else {
        // si es un objeto, ejecuto la función en cada clave del objeto
        for (let index in input) {
            if (typeof input[index] == 'object') {
                removeEmptyFields(input[index])
            }
            if (isEmpty(input[index])) {
                delete input[index]
            }

        }

    }
    return input
}

export const rgbToHex = (rgbColor) => {
    const colors = rgbColor.split('(')[1].split(',').map(color => parseInt(color.replace(/[^0-9]/g, ''), 10))
    return "#" + ((1 << 24) + (colors[0] << 16) + (colors[1] << 8) + colors[2]).toString(16).slice(1)
}

export const cnpjValidator = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    // verificando se tem a quantidade certa de caracter e se não tem todos caracteres iguais
    if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj))
        return false;
    let t = cnpj.length - 2,
        d = cnpj.substring(t),
        d1 = parseInt(d.charAt(0)),
        d2 = parseInt(d.charAt(1)),
        calc = x => {
            let n = cnpj.substring(0, x),
                y = x - 7,
                s = 0,
                r = 0;
            for (let i = x; i >= 1; i--) {
                s += n.charAt(x - i) * y--;
                if (y < 2)
                    y = 9;
            }
            r = 11 - s % 11;
            return r > 9 ? 0 : r;
        }
    return calc(t) === d1 && calc(t + 1) === d2;
}

export const getTimestampColor = (timestamp) => {
    const nowSubstract10 = moment().utc().subtract(10, 'minutes')
    const nowSubstract60 = moment().utc().subtract(60, 'minutes')
    const momentTimestamp = moment.unix(timestamp)
    if (momentTimestamp.isSameOrAfter(nowSubstract10)) {
        return '#66BB6A'
    } else if (momentTimestamp.isSameOrAfter(nowSubstract60) &&
        momentTimestamp.isBefore(nowSubstract10)) {
        return '#d6c105'
    } else if (momentTimestamp.isBefore(nowSubstract60)) {
        return '#ef5350'
    } else {
        return undefined
    }
}

export const speedDetentionToStringTranslated = (
  speed,
  direction,
  stopped,
  stoppedTime,
  trackTimestamp,
  lang,
  returnDirectionStr = false,
) => {
  direction = Number(direction);
  stoppedTime = Number(stoppedTime);
  speed = Number(speed);

  let directionStr = null;
  let cardinalPoint = '';
  if (direction === 0) {
    cardinalPoint = i18n.t('utils.NORTH', { lang }).toString();
    directionStr = 'north';
  } else if (direction === 90) {
    cardinalPoint = i18n.t('utils.EAST', { lang }).toString();
    directionStr = 'east';
  } else if (direction === 180) {
    cardinalPoint = i18n.t('utils.SOUTH', { lang }).toString();
    directionStr = 'south';
  } else if (direction === 270) {
    cardinalPoint = i18n.t('utils.WEST', { lang }).toString();
    directionStr = 'west';
  } else if (direction > 0 && direction < 90) {
    cardinalPoint = i18n.t('utils.NORTH_EAST', { lang }).toString();
    directionStr = 'northeast';
  } else if (direction > 90 && direction < 180) {
    cardinalPoint = i18n.t('utils.SOUTH_EAST', { lang }).toString();
    directionStr = 'southeast';
  } else if (direction > 180 && direction < 270) {
    cardinalPoint = i18n.t('utils.SOUTH_WEST', { lang }).toString();
    directionStr = 'southwest';
  } else if (direction > 270 && direction < 360) {
    cardinalPoint = i18n.t('utils.NORTH_WEST', { lang }).toString();
    directionStr = 'northwest';
  }

  let translation = '';
  if (stopped && (stoppedTime || stoppedTime === 0)) {
    const stoppedTimeConversion = ReportConversionUtil.secondsToString(
      stoppedTime + (moment().utc().unix() - trackTimestamp),
    );
    translation = i18n.t('utils.STOPPED_SINCE', { lang }) + ' ' + stoppedTimeConversion;
  } else if (!stopped && (speed || speed === 0)) {
    if (cardinalPoint.length > 0) {
      translation = speed.toFixed(2) + ' ' + i18n.t('utils.KMH_TO', { lang }) + ' ' + cardinalPoint;
    } else {
      translation = speed.toFixed(2) + ' ' + i18n.t('utils.KMH', { lang });
    }
  } else {
    translation = '';
  }
  return returnDirectionStr ? { translation, directionStr } : translation;
};
